import { ApiBase } from "~/extensions/api";
export class NyukyoInfoApi extends ApiBase {
    find(command) {
        return this.request(command);
    }
}
